<template>
  <a-modal :title="form.id ? '修改转化信息' : '新增转化信息'" :visible="visible" :confirm-loading="confirmLoading" @ok="handleOk"
    @cancel="handleCancel" destroyOnClose :maskClosable="false">
    <a-form-model ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-model-item label="日期" prop="domaincount">
        <a-date-picker :disabled-date="disabledDate" style="width: 100%;" :format="'YYYY/MM/DD'"
          :valueFormat="'YYYY/MM/DD 00:00:00'" v-model="form.day" />
      </a-form-model-item>
      <a-form-model-item label="转化率" prop="conversionrate">
        <a-input-number v-model="form.conversionrate" :min="0" :max="100" :step="0.01" style="width: 100%"
          :formatter="value => `${value}%`" :parser="value => value.replace('%', '')" placeholder="请输入转化率" />
      </a-form-model-item>
      <a-form-model-item label="入私域数量" prop="domaincount">
        <a-input-number v-model="form.domaincount" :min="0" :step="1" :precision='0' style="width: 100%"
          placeholder="请输入入私域数量" />
      </a-form-model-item>
      <a-form-model-item label="三亚咨询人数" prop="sanyaallcount">
        <a-input-number v-model="form.sanyaallcount" :min="0" :step="1" :precision='0' style="width: 100%"
          placeholder="请输入三亚咨询人数" />
      </a-form-model-item>
      <a-form-model-item label="三亚成交数量" prop="sanyacount">
        <a-input-number v-model="form.sanyacount" :min="0" :step="1" :precision='0' style="width: 100%"
          placeholder="请输入三亚成交数量" />
      </a-form-model-item>
      <a-form-model-item label="澳门咨询人数" prop="aomenallcount">
        <a-input-number v-model="form.aomenallcount" :min="0" :step="1" :precision='0' style="width: 100%"
          placeholder="请输入澳门咨询人数" />
      </a-form-model-item>
      <a-form-model-item label="澳门成交数量" prop="aomencount">
        <a-input-number v-model="form.aomencount" :min="0" :step="1" :precision='0' style="width: 100%"
          placeholder="请输入澳门成交数量" />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import moment from 'moment'
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      form: {
        day: '',
        conversionrate: null, //转化率
        domaincount: null, //入私域数量
        sanyaallcount: null, //三亚咨询人数
        sanyacount: null, //三亚成交数量
        aomenallcount: null,//澳门咨询人数
        aomencount: null, //澳门成交数量
      },
      treeData: [],
      groupList: [],
      loadingGroup: false,
      rules: {
        day: [
          {
            required: true,
            message: "请选择",
            trigger: "blur",
          },
        ],
      },
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };
  },
  methods: {
    init(id) {
      this.visible = true;
      this.form.id = id;
      if (id) {
        this.$http({
          url: "/admin/domain/info",
          method: "post",
          data: {
            id: id,
          },
        }).then((res) => {
          this.form = res.data;
        });
      } else {
        this.form.day = moment().format('YYYY-MM-DD 00:00:00')
      }
    },
    disabledDate(current) {
      // 禁用今天之后的日期
      return current && current > new Date();
    },
    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.confirmLoading = true;
          this.$http({
            url: this.form.id ? "/admin/domain/update" : "/admin/domain/create",
            method: "post",
            data: this.form,
          })
            .then(() => {
              this.$message.success(this.form.id ? "修改成功" : "创建成功");
              this.handleCancel();
              this.$emit("ok");
            })
            .catch(() => {
              this.confirmLoading = false;
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleCancel() {
      this.visible = false;
      this.confirmLoading = false;
      this.$refs["ruleForm"].resetFields();
    },
  },
};
</script>

<style>
.custom-tree-node {
  display: flex;
  width: 100%;
  /* border: 1px solid red; */
}
</style>